<template>
  <div class="tenthPage">
    <div class="head">
      <img src="/static/imgs/secondPage/sun.png" />
      <span class="back">ABOUT US</span>
      <span class="front">合作讲师</span>
    </div>
    <el-row class="persons" :gutter="30">
      <el-col v-for="(item,index) in persons" :key="index" :span="6">
        <div class="person">
          <el-card class="card">
            <img :src="item.img" />
            <span v-html="item.name" />
            <span v-html="item.enName" class="lit" />
            <span v-html="item.title" class="lit" />
            <span v-html="item.subTitle" class="lit" />
          </el-card>
          <p class="content" v-html="item.content" />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "tenthPage",
  data() {
    return {
      persons: [
        {
          img: "/static/imgs/tenthPage/1.jpg",
          name: "沈巧慈",
          enName: "Joicy Shen",
          title: "培训界的沉浸式专家",
          subTitle: "<br/>",
          content:
            "先后在航空、咨询、金融、化工等行业的大型企业中负责人力资源工作为多家企业成功实施了包括人事制度建立及改革、培训制度构建及实施、公司文化建设等项目，服务于人力资源领域10多年时间。她还应邀担任了上海大学管理学院的职业导师，并不定期地为学生进行包括面试应对技巧、沟通、商务礼仪等的培训。",
        },
        {
          img: "/static/imgs/tenthPage/2.jpg",
          name: "严佳钰",
          enName: "Ashley Yan",
          title: "专家讲师",
          subTitle: "<br/>",
          content:
            "长期深耕正念觉察、自我赋能和领导力领域，将多年外交战线工作中淬炼出的洞察力、国际一流商学院的领导力项目经验与正念、积极心理学和超个人心理学结合，开发出高效新颖的企业培训课程。先后为大型制造业、国际奢侈品、互联网电商、教育组织、管理咨询、母婴康健、MBA心理协会等各行业培训授课。<br/>十五年大型组织工作经验，曾任复旦大学管理学院外事主管、澳领馆高级签证官、跨国企业大客户负责人、海外公司联合创始人。对体制内、体制外、东方、西方的组织和员工发展都有深刻理解。",
        },
        {
          img: "/static/imgs/tenthPage/3.jpg",
          name: "俞知明",
          enName: "Ken Yu",
          title: "资深培训专家",
          subTitle: "<br/>",
          content:
            "毕业于上海复旦大学工商管理硕士。他的职业生涯开始于一家从事制造业的德国公司并持续了他那长达十多年的职业经理人生涯。从开始的销售经理到之后的中国区销售总经理，他将一支年轻的销售队伍锻炼成行业中的精锐部队，销售额也从十年前的150万欧元增长到现在的1亿欧元，并保持着年平均增长超过20%，连续4年蝉联集团全球销售冠军。<br/>他先后被公司送去欧洲参加世界最顶级培训课程，包括销售技能训练、销售管理训练、沟通技巧、谈判技巧训练等多项训练，期间获得境外EMBA学位。",
        },
        {
          img: "/static/imgs/tenthPage/4.jpg",
          name: "伊健",
          enName: "Ekin Yi",
          title: "沉浸式学习引导师",
          subTitle: "<br/>",
          content:
            "多年的创意活动设计及交付经验，曾担任“阿里巴巴”、 “新城控股”、饿了么等企业组织发展培训工作，熟悉企业文化、领导力发展、构建高绩效团队等主题课程，凭借丰富的实践经验与先进的培训理念, 为多家知名企业完成近千场的培训项目。<br/>利用沉浸式学习方法论进行教学，结合自身对于活动的创意设计，使学员在学习的过程中充分互动，创造出轻松愉快的沉浸式体验环境、促进学员高效学习，快速成长。",
        },
      ],
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.tenthPage {
  margin: 0 0 0 0;
  background-color: whitesmoke;
  padding: 140px 0;
}

.head {
  text-align: center;

  img {
    margin-left: -130px;
  }
  .back {
    position: absolute;
    font-size: 55px;
    color: cornflowerblue;
    margin-left: -90px;
    margin-top: -10px;
    z-index: 0;
    opacity: 0.2;
  }
  .front {
    position: absolute;
    font-size: 45px;
    margin-top: 22px;
    margin-left: -65px;
    margin-top: 10px;
    letter-spacing: 8px;
  }
}

.persons {
  margin-top: 60px;
  padding: 0 20px;
  .person {
    .card {
      display: flex;
      flex-flow: column nowrap;
      background-color: whitesmoke;
      .lit {
        color: #909399;
        margin-top: 4px;
        font-size: 10px;
        font-weight: lighter;
      }
      img {
        width: 100px;
      }
      span {
        display: block;
      }
    }
  }
  .content {
    margin-top: 20px;
    font-size: 13px;
    text-align: left;
    font-family: "";
    background-color: whitesmoke;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tenthPage.vue